import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const LanguagesIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 28) / 30}
      viewBox="0 0 30 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7213 5.17773C5.80008 5.17773 1 9.97776 1 15.8989C1 17.9747 1.59053 19.9122 2.61188 21.5539L1 26.1671L6.26177 25.127C7.86098 26.0752 9.72737 26.6201 11.7213 26.6201C17.6426 26.6201 22.4426 21.8201 22.4426 15.8989C22.4426 9.97776 17.6425 5.17773 11.7213 5.17773Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0879 5.30243C12.0487 2.76563 15.1025 1.1543 18.5568 1.1543C24.478 1.15424 29.2781 5.95427 29.2781 11.8754C29.2781 13.9512 28.6876 15.8887 27.6663 17.5304L29.2781 22.1436L24.0164 21.1035C22.8871 21.7731 21.5367 22.2686 20.19 22.4861"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99609 14.6328V17.1637"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.35938 12.7852V19.0137"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7207 14.6328V17.1637"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.082 13.6582V18.1398"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4434 15.334V16.4629"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

LanguagesIcon.displayName = 'LanguagesIcon'
